export const SESSION_ID_CHANGED = 'SESSION_ID_CHANGED'
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'
export const MESSAGE_RECEIVED = 'MESSAGE_RECEIVED'
export const SEND_MESSAGE = 'SEND_MESSAGE'
export const CREATE_CHANNEL = 'CREATE_CHANNEL'
export const AVAILABLE_CHANNELS_CHANGED = 'AVAILABLE_CHANNELS_CHANGED'
export const ONLINE_USERS_CHANGED = 'ONLINE_USERS_CHANGED'
export const CHAT_SOCKET_CHANGED = 'CHAT_SOCKET_CHANGED'
export const USER_SELF_CHANGED = 'USER_SELF_CHANGED'
export const INIT = 'INIT'
export const EXIT = 'EXIT'



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/events/actionIds.ts